// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 198 ? "BaseRoutes" : chunkId) + "." + {"70":"113ba0d0","198":"dd835344","448":"ec481af5","554":"e7f65410","971":"5b17b968"}[chunkId] + ".chunk.css";
};